import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { PersonaCheckboxDisplayOption } from '../store/schema/PersonaCheckboxDisplayOption';
import getPersonaCheckboxDisplay from '../store/selectors/getPersonaCheckboxDisplay';

/**
 * Returns whether the message list checkboxes (the select all checkbox in the
 * header and the per-row checkbox in the message list) should be hidden.
 *
 * The checkboxes are hidden when the ML checkbox behavior flight is enabled and
 * the user selected the "name only" leading element (no sender image, no checkbox).
 */
export default function shouldHideMessageListCheckboxes(): boolean {
    return (
        isGlobalFeatureEnabled('tri-mlCheckboxBehavior') &&
        getPersonaCheckboxDisplay() === PersonaCheckboxDisplayOption.ShowNameOnly
    );
}
